// src/modules/Courier/pages/CourierModal/pages/Scanners/ScannerV2.jsx
import React, { useEffect, useRef, useState } from "react";
import { Html5Qrcode } from "html5-qrcode";
import styles from './styles/ScannerV2.module.css';
import shutterSoundFile from './camera-shutter.mp3';
import { BiCog } from 'react-icons/bi';
import { useModalPage } from '../../CourierModal';

export default function ScannerV2({ onMarkScanned, onPhotoCaptured }) {
  const overlayKey   = 'scanner.overlaySize';
  const qrboxKey        = 'scanner.useQrBox';
  const [overlaySize, setOverlaySize] = useState(() => {
  const v = localStorage.getItem(overlayKey);
    return v === null ? 250 : Number(v);
  });
    // новый флаг: использовать qrbox?
  const [useQrBox, setUseQrBox] = useState(() => {
    const v = localStorage.getItem(qrboxKey);
    return v === null ? true : v === 'true';
  });

  const scannerRef      = useRef(null);
  const canvasRef       = useRef(null);
  const flashOverlayRef = useRef(null);
  const shutterAudio    = useRef(new Audio(shutterSoundFile));
  const [flashOn, setFlashOn] = useState(false);
  const [photoFlash, setPhotoFlash] = useState(false);
  const { goTo } = useModalPage();
  // Старт/стоп сканера на монтирование/размонтирование
  useEffect(() => {
    startScanner();
    return () => stopScanner();
  }, []);

  useEffect(() => {
  localStorage.setItem(overlayKey, String(overlaySize));
  localStorage.setItem(qrboxKey, String(useQrBox));
  }, [overlaySize]);

  // Переключаем torch при изменении flashOn (через video.element)
  useEffect(() => {
    const video = document.querySelector("#scanner-container video");
    if (!video || !video.srcObject) return;
    const [track] = video.srcObject.getVideoTracks();
    if (!track) return;
    const capabilities = track.getCapabilities();
    if (capabilities.torch) {
      track
        .applyConstraints({ advanced: [{ torch: flashOn }] })
        .catch(err => console.warn("Не удалось переключить фонарь:", err));
    }
  }, [flashOn]);

  

  const startScanner = async () => {
    if (scannerRef.current) {
      console.log("⚠️ Scanner already running");
      return;
    }
    console.log("🔧 Initializing Html5Qrcode");
    const qr = new Html5Qrcode("scanner-container");
    scannerRef.current = qr;
    const config = { fps: 10, disableFlip: false, ...(useQrBox ? { qrbox: { width: overlaySize, height: overlaySize } } : {}) };
    try {
      //await qr.start({ facingMode: "environment" },
      await qr.start({ facingMode: "environment" },config, decoded => onMarkScanned(decoded),);
        //{ facingMode: { exact: "environment" } },
        //{ fps: 10, qrbox: { width: 250, height: 250 } },
        //{ fps: 10  , disableFlip: false  },
        //{ fps: 10, qrbox: { width: overlaySize, height: overlaySize } },
       } catch (e) {
       console.error("❌ Ошибка запуска сканера:", e.message);
       scannerRef.current = null;
     }
   };

  const stopScanner = async () => {
    if (!scannerRef.current) {
      console.log("⚠️ Scanner already stopped");
      return;
    }
    console.log("🛑 Attempting to stop Html5Qrcode");
    try {
      await scannerRef.current.stop();
      console.log("🛑 Scanner stopped successfully");
      await scannerRef.current.clear();
      console.log("🧹 Scanner container cleared");
    } catch (err) {
      console.warn("⚠️ stop() or clear() error:", err);
    } finally {
      scannerRef.current = null;
    }
  };

  const toggleFlash = () => setFlashOn(v => !v);

  const capturePhoto = () => {
    const video = document.querySelector("#scanner-container video");
    const canvas = canvasRef.current;
    if (!video || !canvas) {
      console.warn("⚠️ Видео или canvas не найдены");
      return;
    }
    // flash effect
    flashOverlayRef.current?.classList.add(styles.flashEffect);
    setTimeout(() => flashOverlayRef.current?.classList.remove(styles.flashEffect), 100);
    // shutter sound
    shutterAudio.current.currentTime = 0;
    shutterAudio.current.play();
    // draw
    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;
    const ctx = canvas.getContext("2d");
    ctx.drawImage(video, 0, 0);
    canvas.toBlob(blob => blob && onPhotoCaptured(blob), "image/png");
  };

  return (
    <div className={styles.container}>
      <div id="scanner-container" className={styles.videoContainer}>
        <div ref={flashOverlayRef} className={styles.flashOverlay} />
        <div className={styles.scanZone}><span/></div>
      </div>

      <canvas ref={canvasRef} className={styles.hiddenCanvas} />

      <div className={styles.controls}>
        <button
          type="button"
          className={`${styles.flashButton} ${flashOn ? styles.flashOnActive : ''}`}
          onClick={toggleFlash}
          title={flashOn ? "Выключить фонарик" : "Включить фонарик"}
        >
          <i className={`bi ${flashOn ? 'bi-lightbulb-fill' : 'bi-lightbulb'}`} />
        </button>

       <button
        type="button"
        className={styles.settingsButton}
        onClick={() => goTo('scannerSettings')}
        title="Настройки сканера"
      >
        <i className="bi bi-gear-fill" />
      </button>
        <button
          type="button"
          className={`${styles.photoButton} ${photoFlash ? styles.photoFlashActive : ''}`}
          onClick={capturePhoto}
          title="Сделать фото"
        >
          <i className="bi bi-camera-fill" />
        </button>
      </div>
    </div>
  );
}